// CRM next-action options offered when sending an outreach draft.
//
// company.crm_next_action is an unconstrained CharField, so this list -- not the
// database -- defines what is selectable. CRMNextActionCell.vue and
// CompanyBulkActions.vue each carry their own near-identical copy; this one is
// deliberately separate because it omits 'Send LinkedIn InMail', which those
// two still offer.
export const CRM_NEXT_ACTION_OPTIONS = [
    {value: 'None', label: 'None'},
    {value: 'Determine Next Action', label: 'Determine Next Action'},
    {value: 'Scott to Follow-Up', label: 'Scott to Follow-Up'},
    {value: 'BA to Follow-Up', label: 'BA to Follow-Up'},
    {value: 'LG to Follow-Up', label: 'LG to Follow-Up'},
    {value: 'CB to Follow-Up', label: 'CB to Follow-Up'},
    {value: 'Send Initial Email', label: 'Send Initial Email'},
    {value: 'Send Another Email', label: 'Send Another Email'},
    {value: 'Send Email on Acquisition', label: 'Send Email on Acquisition'},
    {value: 'Research Correct Email', label: 'Research Correct Email'},
    {value: 'Call', label: 'Call'},
    {value: 'Schedule Meeting', label: 'Schedule Meeting'},
    {value: 'Wait on Response', label: 'Wait on Response'},
    {value: 'Wait for Client Feedback', label: 'Wait for Client Feedback'},
    {value: 'Meet', label: 'Meet'},
    {value: 'Not Now', label: 'Not Now'},
    {value: 'Leave Alone', label: 'Leave Alone'},
    {value: 'Referral Source to Reach Out', label: 'Referral Source to Reach Out'},
    {value: 'Send 2nd Email', label: 'Send 2nd Email'},
    {value: 'Send 3rd Email', label: 'Send 3rd Email'},
    {value: 'Send 4th Email', label: 'Send 4th Email'},
    {value: 'Cold Call 1', label: 'Cold Call 1'},
    {value: 'Cold Call 2', label: 'Cold Call 2'},
    {value: 'Call again', label: 'Call again'},
    {value: 'Periodic Check In', label: 'Periodic Check In'},
    {value: 'Submit IOI', label: 'Submit IOI'},
    {value: 'Submit LOI', label: 'Submit LOI'},
]
